
import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { BIconPersonFill } from 'bootstrap-vue';
import { statusVariant, statusLabelKey } from './ticketStatus';

@Component({
  components: { BIconPersonFill },
  computed: { ...mapGetters(['locale']) },
})
export default class TicketListItem extends Vue {
  @Prop({ required: true }) ticket!: any;
  @Prop({ default: false }) selected!: boolean;

  locale!: string;

  get variant() {
    return statusVariant(this.ticket.status);
  }
  get labelKey() {
    return statusLabelKey(this.ticket.status);
  }
  get hasJobs() {
    return Array.isArray(this.ticket.jobs) && this.ticket.jobs.length > 0;
  }
  get createdAt() {
    return this.ticket.createdAt
      ? moment(this.ticket.createdAt).locale(this.locale).format('L')
      : '';
  }
}
